import request from '@/utils/request';
// 获取门店树形列表
export function getStoreTreeList() {
  return request('/store/queryTreeList', {
    method: 'GET',
  });
}

//短信报表
export function getQueryReport(values) {
  return request('/mms/queryReport', {
    method: 'POST',
    data: values,
  });
}
//短信报表概要
export function getQueryReportSummary(values) {
  return request('/mms/queryReportSummary', {
    method: 'POST',
    data: values,
  });
}
